<template>
  <page :title="i18n.title" background="#F8F6FC">
    <div class="setting-warp">
      <div class="setting-row" @click="isLangView = true">
        <div class="setting-row-label">{{i18n.lang}}</div>
        <span>{{locale&&locale.label}}</span>
        <img src="../../assets/imgs/icon_more.png" alt="">
      </div>
      <div class="setting-row" @click="onHref('https://m.beesmartconnect.com/content/user_agreement.html')">
        <div class="setting-row-label">{{i18n.user_agreement}}</div>
        <img src="../../assets/imgs/icon_more.png" alt="">
      </div>
      <div class="setting-row" @click="onHref('https://m.beesmartconnect.com/content/privacy_policy.html')">
        <div class="setting-row-label">{{i18n.privacy_policy}}</div>
        <img src="../../assets/imgs/icon_more.png" alt="">
      </div>
      <div class="setting-row">
        <div class="setting-row-label">{{i18n.time_zone}}</div>
        <span>{{ getTimeZone() }}</span>
      </div>
      <div class="setting-row" @click="onLogout">
        <div class="setting-row-label" style="color: #F23517;">{{i18n.logout}}</div>
        <img src="../../assets/imgs/icon_more.png" alt="">
      </div>
      <select-lang v-model="isLangView"></select-lang>
    </div>
  </page>
</template>

<script>
import { SelectLang } from '../../components/select'
import { mapGetters } from 'vuex'
export default {
  components: {
    SelectLang
  },
  computed: {
    ...mapGetters(['locale']),
    i18n () {
      return this.$t('setting')
    },
    msgI18n () {
      return this.$t('msg')
    }
  },
  data () {
    return {
      isLangView: false
    }
  },
  methods: {
    onHref(path) {
      window.location.href = path
    },
    getTimeZone() {
      const date = new Date();
      const offset = date.getTimezoneOffset();
      const hours = Math.abs(Math.floor(offset / 60));
      const sign = offset > 0 ? '-' : '+';
      return `GMT${sign}${hours}`;
    },
    onLogout() {
      this.$confirm({
        title: this.msgI18n.title,
        content: this.msgI18n.sure_logout,
        confirmText: this.msgI18n.confirm,
        cancelText: this.msgI18n.cancel
      }).then(() => {
        this.$store.commit("token", null)
        this.$store.commit("user", null)
        this.$router.replace("/login")
      });
    }
  }
}
</script>

<style lang="less">
.setting-warp {
  padding: 48px;
  background-color: #F8F6FC;
  padding: 53px;
  height: calc(100vh - 194px);
  .setting-row {
    background-color: #fff;
    height: 105px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px 0 35px;
    font-size: 28px;
    color: #7F7F7F;
    border-radius: 20px;
    margin-bottom: 28px;
    .setting-row-label {
      flex: 1;
      color: #000;
      font-size: 32px;
    }
    img {
      width: 44px;
      height: 44px;
    }
  }
}
</style>
